import React from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { Settings } from 'lucide-react';

interface ProductTableHeaderProps {
  filteredCount: number;
  totalProducts: number;
  pagination: {
    page: number;
    limit: number;
  };
  showVariations: boolean;
  setShowVariations: (show: boolean) => void;
  handlePageChange: (page: number) => void;
  handlePageSizeChange: (size: number) => void;
}

export const ProductTableHeader: React.FC<ProductTableHeaderProps> = ({
  filteredCount,
  totalProducts,
  pagination,
  showVariations,
  setShowVariations,
  handlePageChange,
  handlePageSizeChange,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-2">
      <div className="d-flex align-items-center gap-3">
        <img
          src="https://skin-seoul.com/wp-content/uploads/2024/12/desktop-logo.png"
          alt="SkinSeoul"
          style={{ height: '34px', width: 'auto', margin: '1px' }}
        />
      </div>
      <div className="ms-auto d-flex align-items-center gap-2">
        <small style={{ color: '#ccc' }}>
          {filteredCount} of {totalProducts} product{totalProducts !== 1 ? 's' : ''}
        </small>
        {/* Pagination Controls */}
        {totalProducts > pagination.limit && (
          <div className="d-flex align-items-center gap-1">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handlePageChange(pagination.page - 1);
              }}
              disabled={pagination.page === 1}
              style={{ borderColor: '#555', color: '#ccc', padding: '2px 8px' }}
            >
              ←
            </Button>
            <small style={{ color: '#ccc', minWidth: '60px', textAlign: 'center' }}>
              Page {pagination.page} of {Math.ceil(totalProducts / pagination.limit)}
            </small>
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handlePageChange(pagination.page + 1);
              }}
              disabled={pagination.page >= Math.ceil(totalProducts / pagination.limit)}
              style={{ borderColor: '#555', color: '#ccc', padding: '2px 8px' }}
            >
              →
            </Button>
          </div>
        )}
        <Dropdown>
          <Dropdown.Toggle
            variant="outline-secondary"
            size="sm"
            style={{ borderColor: '#555', color: '#ccc', padding: '2px 8px' }}
          >
            <Settings size={14} />
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Header>Per Page</Dropdown.Header>
            <Dropdown.Item onClick={() => handlePageSizeChange(100)} active={pagination.limit === 100}>
              100
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handlePageSizeChange(300)} active={pagination.limit === 300}>
              300
            </Dropdown.Item>
            <Dropdown.Item onClick={() => handlePageSizeChange(500)} active={pagination.limit === 500}>
              500
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Header>Display Options</Dropdown.Header>
            <Dropdown.Item
              onClick={() => setShowVariations(!showVariations)}
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <input
                type="checkbox"
                checked={showVariations}
                onChange={() => setShowVariations(!showVariations)}
                style={{ margin: 0 }}
              />
              Show Variations
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};
